module.exports = __webpack_public_path__ + "static/blue_checked_icon.be0ccd6a.svg";